import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { getComplimentaryPeriodActionLabel } from 'src/components/SidePanelTabs/MembershipInformation/subscription-details.utils';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';
import {
  AddComplimentaryPeriodForm,
  AddComplimentaryPeriodFormValues,
} from './add-complimentary-period-form';
import { getCppLengthList, TODAY_DATE } from './const';
import { prepareCppData } from './util';

export interface CppPayload {
  expDate: string;
  partnerProductId: string;
}

export const AddComplimentaryPeriodModal = () => {
  const { closeModal } = useModalMethods(Modals.AddComplimentaryPeriod);
  const { isOpened, modalProps } = useModalState(Modals.AddComplimentaryPeriod);

  const formMethods = useForm<AddComplimentaryPeriodFormValues>({
    defaultValues: {
      partnerProductId: '',
      cppExpirationDate: getCppLengthList(TODAY_DATE)[0].value,
    },
  });

  const onSubmit = useCallback(
    async (data: AddComplimentaryPeriodFormValues) => {
      if (!modalProps?.address?.addressId || !modalProps?.address?.partnerId) {
        return;
      }

      const cppData = prepareCppData(data);

      formMethods.reset();
      closeModal();

      await modalProps?.addCppToSchedule?.({
        addressId: modalProps?.address?.addressId,
        partnerId: modalProps?.address?.partnerId,
        cpp: cppData,
      });
    },
    [closeModal, modalProps, formMethods],
  );

  const handleClose = useCallback(() => {
    formMethods.reset();
    closeModal();
  }, [closeModal, formMethods]);

  return (
    <Dialog open={isOpened} onClose={handleClose} fullWidth>
      <DialogTitle>
        <Typography>
          {getComplimentaryPeriodActionLabel(modalProps?.address?.cppExpDate)}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <AddComplimentaryPeriodForm
          formMethods={formMethods}
          onSubmit={onSubmit}
          address={modalProps?.address}
        />
      </DialogContent>
    </Dialog>
  );
};
